import React, { useEffect } from 'react'
import { graphql } from 'gatsby'
import { NavBar } from '../components/NavBar'
import RelatedArticles from '../components/Article/RelatedArticles'

import Takeaways from '../components/Article/Takeaways'
import Resources from '../components/Article/Resources'
import SectionMarker from '../components/Article/SectionMarker'

import ArticleLayout from '../components/Article/ArticleLayout'
import FullLayout from '../components/Article/FullLayout'
import LayoutSerializer from '../components/Serializers/LayoutSerializer'
import ScrollProgress from '../components/Article/ScrollProgress'
import { useStore } from '../lib/context'
import { observer } from 'mobx-react-lite'
import { Footer } from '../components/General'
import { Meta } from '../components/Meta'
import { hexToRgbaString } from '../lib/helpers'
import { FullScreenImageModal } from '../components/Article/ImageGalleries'
import { MobileNumberedSelectorButtons } from '../components/Article/Lists/NumberedSelectorComponents'

import { ArticleTop } from '../components/Article'
import { UtilityNav } from '../components/UtilityNav'

export default observer(({ data }) => {
  const article = data.contentfulArticle
  const { content, articleTop } = article

  const {
    uiStore: {
      updateArticlePrimaryColor,
      updateArticleSecondaryColor,
      updateArticleUIHoverColor,
      updateArticleTextHighlightColor,
      updateNavBarColor,
      updateNavBarTextColor,
      updateFooterColor,
      updateFooterTextColor,
      updateArticleSectionMarkers,
    },
  } = useStore()

  const {
    title,
    description,
    heroImage,
    primaryColor,
    secondaryColor,
    textHighlightColor,
    uiHoverColor,
  } = article

  const initializeColors = () => {
    updateNavBarColor(hexToRgbaString(primaryColor))
    updateNavBarTextColor(hexToRgbaString(textHighlightColor))
    updateFooterColor(hexToRgbaString(primaryColor))
    updateFooterTextColor(hexToRgbaString(textHighlightColor))
    updateArticlePrimaryColor(hexToRgbaString(primaryColor))
    updateArticleSecondaryColor(hexToRgbaString(secondaryColor))
    updateArticleUIHoverColor(uiHoverColor)
    updateArticleTextHighlightColor(hexToRgbaString(textHighlightColor))
  }

  useEffect(() => {
    const sectionMarkers = article.content.filter(
      (c) => c.__typename === 'ContentfulSectionMarker'
    )
    updateArticleSectionMarkers(sectionMarkers)
    initializeColors()
  }, [])

  return (
    <>
      <Meta
        title={title}
        description={description}
        image={heroImage}
        author={articleTop?.byLines}
      />
      {/* <UtilityNav /> */}
      {/* <NavBar hideOnScroll hasExitButton /> */}
      <FullScreenImageModal />
      <MobileNumberedSelectorButtons />
      <ArticleLayout>
        <ArticleTop content={articleTop} />
        {/* DYNAMIC LAYOUT */}
        <LayoutSerializer content={content} />
        {/* DYNAMIC LAYOUT */}
        <FullLayout>
          {article?.canScrollToTakeaways && <SectionMarker />}
          <Takeaways takeaways={article?.takeaways} />
          {article?.canScrollToResources && <SectionMarker />}
          <Resources resources={article?.resources} />
          {article?.canScrollToRelatedArticles && <SectionMarker />}
          <RelatedArticles relatedArticles={article?.relatedArticles} />

          {/* <Footer /> */}
        </FullLayout>
      </ArticleLayout>
      {/* <ScrollProgress /> */}
    </>
  )
})

export const query = graphql`
  query($slug: String!) {
    contentfulArticle(slug: { eq: $slug }) {
      title
      author
      primaryColor
      secondaryColor
      uiHoverColor
      textHighlightColor
      canScrollToTakeaways
      canScrollToResources
      canScrollToRelatedArticles

      ...ArticleTop
      textBlock {
        raw
      }
      heroImage {
        title
        description
        resolutions {
          aspectRatio
        }
        file {
          url
          fileName
          contentType
        }
      }
      ...Resources

      content {
        ...SectionMarker
        ...FullLayout
        ...HalfCenteredLayout
        ...HalfLayout
      }
      ...RelatedArticles
      ...Takeaways
    }
  }
`
